module.exports = "<h1 class=\"md-display-1 gmao-warn\">{{'ui.forbidden' | translate}}</h1>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/main/front/scripts/module/security/component/forbidden.html
// module id = 283
// module chunks = 1